import script from "./ContactsWebEntry.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactsWebEntry.vue?vue&type=script&setup=true&lang=ts"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__